document.addEventListener('DOMContentLoaded', function() {
  const jsonElement = document.querySelector('[data-product-json]');
  const metafieldsElement = document.querySelector('[data-variant-metafields]');

  if (!jsonElement) return;

  const variants = JSON.parse(jsonElement.innerHTML);
  const variantMetafields = metafieldsElement ? JSON.parse(metafieldsElement.innerHTML) : {};

  const masterVariantInput = document.getElementById('VariantID');
  const descriptionContainer = document.getElementById('VariantDescriptionContainer');
  const foodImageContainer = document.getElementById('VariantFoodImageContainer');
  const addToCartForm = document.querySelector('form[action^="/cart/add"]'); 

  // DRAG AND DROP FILE UPLOAD ENGINE
  const fileDropArea = document.getElementById('FileDropArea');
  const fileInput = document.getElementById('CustomLogo');
  const noBrandingRadio = document.getElementById('NoBranding');
  const fileNameDisplay = document.getElementById('FileNameDisplay');
  const preview = document.getElementById('LogoPreview');
  const logoPositionSelect = document.getElementById('LogoPositionSelect');
  const logoSizeSlider = document.getElementById('LogoSizeSlider');
  const logoSizeValue = document.getElementById('LogoSizeValue');
  const logoEditingContainer = document.getElementById('logo-editing-container');
  const originalLogoNameInput = document.getElementById('OriginalLogoName');
  const yesBrandingRadio = document.getElementById('YesBranding');
  const brandingCheckboxesContainer = document.getElementById('BrandingCheckboxesContainer');
  const brandingUploadContainer = document.getElementById('BrandingUploadContainer');
  const cartBrandingCb = document.getElementById('Addon-CartBranding');
  const packBrandingCb = document.getElementById('Addon-PackagingBranding');

  // --- IDENTIFY CART TYPE & HELPER FUNCTION ---
  const summaryListEl = document.getElementById('OverviewSelectionList');
  const isCurvedCart = summaryListEl && summaryListEl.getAttribute('data-product-title') 
      ? summaryListEl.getAttribute('data-product-title').toLowerCase().includes('curved') 
      : false;

  // --- THUMBNAIL CLICK-TO-SWAP ENGINE ---
  if (foodImageContainer) {
    foodImageContainer.style.cursor = 'pointer';
    foodImageContainer.addEventListener('click', function() {
      isViewingFoodImage = !isViewingFoodImage;
      activeAddonImageUrl = null; // Clear addon state
      updateFormState(); 
    });
  }

  function applyCartLogoConstraints(previewEl, positionValue) {
      if (!previewEl) return;
      const isCanopy = positionValue === 'Canopy';
      
      if (isCurvedCart) {
          // Curved Cart adjustments: 
          // Canopy is narrower/shorter. Bar is slightly higher and shorter.
          previewEl.style.top = isCanopy ? '8.8%' : '61%'; 
          previewEl.style.width = '23%'; 
          previewEl.style.height = isCanopy ? '5.5%' : '10%'; 
      } else {
          // Default Box Cart constraints
          previewEl.style.top = isCanopy ? '8.8%' : '64%';
          previewEl.style.width = '26%';
          previewEl.style.height = '10%';
      }
  }

  const validPostcodes = [
    '2000', '2006', '2007', '2008', '2009', '2010', '2011', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032', '2033', '2034', '2035', '2036', '2037', '2038', '2039', '2040', '2041', '2042', '2043', '2044', '2045', '2046', '2047', '2048', '2049', '2050', '2055', '2060', '2061', '2062', '2063', '2064', '2065', '2066', '2067', '2068', '2069', '2070', '2071', '2072', '2073', '2074', '2075', '2076', '2077', '2079', '2080', '2084', '2085', '2086', '2087', '2088', '2089', '2090', '2092', '2093', '2094', '2095', '2096', '2097', '2099', '2100', '2101', '2102', '2103', '2104', '2110', '2111', '2112', '2113', '2114', '2115', '2116', '2117', '2118', '2119', '2120', '2121', '2122', '2125', '2126', '2127', '2128', '2130', '2131', '2132', '2133', '2134', '2135', '2136', '2137', '2138', '2140', '2141', '2142', '2143', '2144', '2145', '2146', '2147', '2150', '2151', '2152', '2154', '2158', '2160', '2161', '2162', '2163', '2165', '2166', '2167', '2168', '2170', '2171', '2172', '2176', '2177', '2190', '2191', '2192', '2193', '2194', '2195', '2196', '2197', '2198', '2199', '2200', '2203', '2204', '2205', '2206', '2207', '2208', '2209', '2210', '2211', '2212', '2213', '2214', '2216', '2217', '2218', '2219', '2220', '2221', '2222', '2223', '2224', '2225', '2226', '2227', '2228', '2229', '2230', '2231', '2232', '2233', '2234', '2564'
  ];

  // --- POSTCODE STRICT NUMBER ENFORCER ---
  const postcodeInput = document.getElementById('postcode');
  if (postcodeInput) {
    postcodeInput.addEventListener('input', function(e) {
      // Instantly strip out any character that is not a digit (0-9)
      this.value = this.value.replace(/\D/g, '');
      
      // Trigger the main validation engine after cleaning the input
      validateStep4();
    });
  }
  
  // State memory to track which image is currently the hero
  let isViewingFoodImage = false;
  let activeAddonImageUrl = null;

  // --- FLATPICKR DATE RESTRICTION ENGINE ---
  const eventDateInput = document.getElementById('EventDate');
  const calendarWrapper = document.getElementById('calendar-wrapper');

  if (calendarWrapper) {
    setTimeout(() => {
      const disabledDates = isCurvedCart 
        ? (window.fullyBookedDates?.curvedCarts || []) 
        : (window.fullyBookedDates?.boxCarts || []);

      // Grab dynamic setting, default to 7, add 1 to match your original logic of blocking "today + next X days"
      const noticeDays = (window.minDaysNotice || 7) + 1; 

      flatpickr(calendarWrapper, {
        inline: true, // This forces the "always visible" look
        dateFormat: "Y-m-d",
        minDate: new Date().fp_incr(noticeDays), 
        disable: disabledDates,
        onChange: function(selectedDates, dateStr, instance) {
          // Sync the selection to your hidden input so the form submission catches it
          eventDateInput.value = dateStr;
          if (typeof validateStep4 === 'function') {
            validateStep4();
          }
        }
      });
    }, 50);
  }

  const packagingBrandingMap = {
    '50 serves': { id: '47122515722415', price: 10000 },
    '100 serves': { id: '47122515755183', price: 20000 },
    '200 serves': { id: '47122515787951', price: 40000 }
  };

  // Helper: Formats prices like "$1,500"
  function formatMoney(cents) {
      const dollars = cents / 100;
      return '$' + dollars.toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  // THE MASTER FORM STATE ENGINE
  function updateFormState() {
    let selectedOptions = {
      option1: document.querySelector('.actual-variant-radio[data-index="option1"]:checked')?.value || null,
      option2: document.querySelector('.actual-variant-radio[data-index="option2"]:checked')?.value || null,
      option3: document.querySelector('.actual-variant-radio[data-index="option3"]:checked')?.value || null,
    };

    const baseFilterRadios = document.querySelectorAll('.base-filter-radio:checked');
    
    baseFilterRadios.forEach(baseRadio => {
    const optionIndex = baseRadio.getAttribute('data-option-index'); 
    const baseValue = baseRadio.value;
    const dropdownGroup = document.querySelector(`.sub-option-dropdown-group[data-index="${optionIndex}"]`);
    const selectEl = dropdownGroup?.querySelector('select');
    
    if (!selectEl) return;

    const matchCriteria = {};
    if (optionIndex !== 'option1') matchCriteria.option1 = selectedOptions.option1;
    if (optionIndex !== 'option2') matchCriteria.option2 = selectedOptions.option2;
    if (optionIndex !== 'option3') matchCriteria.option3 = selectedOptions.option3;

    let availableVariants = variants.filter(v => {
      let match = true;
      for (let key in matchCriteria) {
      if (matchCriteria[key] && v[key] !== matchCriteria[key]) match = false;
      }
      return match;
    });

    let subVariants = availableVariants.filter(v => {
        let val = v[optionIndex];
        return val === baseValue || val.startsWith(baseValue + " -");
    });

    const hasSubOptions = subVariants.some(v => v[optionIndex].includes(" - "));

    if (hasSubOptions) {
      dropdownGroup.style.display = 'block';
      
      const label = dropdownGroup.querySelector('.sub-option-label');
      if (label) label.textContent = `Please choose what type of ${baseValue.toLowerCase()} you would like served.`;
      
      const currentSelectValue = selectEl.value; 
      
      selectEl.innerHTML = '';
      const defaultOpt = document.createElement('option');
      defaultOpt.value = '';
      defaultOpt.textContent = 'Please choose...';
      defaultOpt.disabled = true;
      if (!currentSelectValue) defaultOpt.selected = true;
      selectEl.appendChild(defaultOpt);

      subVariants.forEach(v => {
      const optVal = v[optionIndex];
      const priceStr = formatMoney(v.price);
      
      let displayVal = optVal.includes(" - ") ? optVal.split(" - ")[1] : optVal;
      displayVal = `${displayVal} — ${priceStr}`;

      const opt = document.createElement('option');
      opt.value = optVal;
      opt.textContent = displayVal;
      if (optVal === currentSelectValue) opt.selected = true;
      selectEl.appendChild(opt);
      });
      
      selectedOptions[optionIndex] = selectEl.value;
        
    } else {
      dropdownGroup.style.display = 'none';
      selectedOptions[optionIndex] = baseValue;
    }
    });

    const matchedVariant = variants.find(variant => {
    return variant.option1 === selectedOptions.option1 &&
      variant.option2 === selectedOptions.option2 &&
      variant.option3 === selectedOptions.option3;
    });

    // Find a partial match to grab prices/images even if the user hasn't finished picking a food dropdown yet
    const partialMatchVariant = matchedVariant || variants.find(variant => {
      let match = true;
      if (selectedOptions.option1 && variant.option1 !== selectedOptions.option1) match = false;
      if (selectedOptions.option2 && variant.option2 !== selectedOptions.option2) match = false;
      if (selectedOptions.option3 && variant.option3 !== selectedOptions.option3) match = false;
      return match;
    }) || variants[0];

    // --- DYNAMIC VARIANT OPTIONS ENGINE ---
    const dynamicContainer = document.getElementById('DynamicVariantOptionsContainer');
    const dynamicWrapper = document.getElementById('DynamicVariantOptionsWrapper');
    
    // Build options based on the currently viewed partial variant so they show immediately
    const activeVariantForMeta = matchedVariant || partialMatchVariant;
    const metaData = activeVariantForMeta ? variantMetafields[activeVariantForMeta.id] : null;

    if (dynamicContainer && dynamicWrapper) {
        if (metaData && metaData.variant_options && metaData.variant_options.length > 0) {
            dynamicContainer.style.display = 'block';
            
            // Only rebuild the DOM elements if the option list actually changed (prevents unchecking user selections)
            const optionsStr = JSON.stringify(metaData.variant_options);
            if (dynamicWrapper.dataset.renderedOptions !== optionsStr) {
                dynamicWrapper.innerHTML = '';
                
                metaData.variant_options.forEach((optText, index) => {
                    const cleanId = 'DynamicOpt-' + optText.replace(/[^a-zA-Z0-9]/g, '-');
                    
                    const wrap = document.createElement('div');
                    wrap.className = 'checkbox-wrapper body-medium';
                    
                    const input = document.createElement('input');
                    input.type = 'checkbox';
                    input.id = cleanId;
                    // Format correctly for Shopify Cart properties
                    input.name = `properties[Include ${optText}]`;
                    input.value = 'Yes';
                    input.className = 'dynamic-variant-checkbox';
                    
                    const label = document.createElement('label');
                    label.setAttribute('for', cleanId);
                    label.textContent = optText;
                    
                    wrap.appendChild(input);
                    wrap.appendChild(label);
                    dynamicWrapper.appendChild(wrap);
                });
                
                dynamicWrapper.dataset.renderedOptions = optionsStr;
            }
        } else {
            dynamicContainer.style.display = 'none';
            // Clear checked states if container is hidden
            dynamicWrapper.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
        }
    }

    // Update hidden input and description ONLY if a complete variant is formed
    if (matchedVariant && masterVariantInput) {
      masterVariantInput.value = matchedVariant.id;
      masterVariantInput.dataset.completeVariant = "true"; 
      
      if (descriptionContainer) {
        const newDescription = variantMetafields[matchedVariant.id]['description'];
        if (newDescription) {
          descriptionContainer.innerHTML = newDescription;
          descriptionContainer.style.display = 'block';
        } else {
          descriptionContainer.innerHTML = '';
          descriptionContainer.style.display = 'none';
        }
      }
    } else {
       if (descriptionContainer) descriptionContainer.style.display = 'none';
       if (masterVariantInput) masterVariantInput.dataset.completeVariant = "false"; 
    }

    // --- LIVE IMAGE SWAP UPDATE ---
    const activeImageVariant = matchedVariant || partialMatchVariant;
    if (activeImageVariant && activeImageVariant.featured_image && activeImageVariant.featured_image.src) {
      const mainImage = document.querySelector('.product-image__wrapper img:not(#LogoPreview)');
      if (mainImage) {
        mainImage.src = activeImageVariant.featured_image.src;
        if (mainImage.hasAttribute('srcset')) {
          mainImage.removeAttribute('srcset');
        }
      }
    }

    // --- LIVE ORDER OVERVIEW UPDATE ---
    // Moved outside the if() statement so it instantly updates the UI on every single click!
    const summaryList = document.getElementById('OverviewSelectionList');
    const totalPriceEl = document.getElementById('OverviewTotalPrice');
    
    if (summaryList && totalPriceEl) {
      // Clear the old list
      summaryList.innerHTML = '';
      
      // 0. Add the main Product Title
      const productTitle = summaryList.getAttribute('data-product-title');
      if (productTitle) {
        summaryList.innerHTML += `<li>${productTitle}</li>`;
      }
      
      // 1. Add the selected Variant Options (shows them live as they click them)
      if (selectedOptions.option1) summaryList.innerHTML += `<li>${selectedOptions.option1}</li>`;
      if (selectedOptions.option2) summaryList.innerHTML += `<li>${selectedOptions.option2}</li>`;
      if (selectedOptions.option3) summaryList.innerHTML += `<li>${selectedOptions.option3}</li>`;
      
      // 2. Add the selected Dynamic Options
      if (dynamicContainer && dynamicContainer.style.display !== 'none') {
        const selectedDynamic = dynamicWrapper.querySelectorAll('input[type="checkbox"]:checked');
        selectedDynamic.forEach(opt => {
          summaryList.innerHTML += `<li>${opt.nextElementSibling.textContent}</li>`;
        });
      }

      // 3. Start calculating the total price using the partial match
      let totalCents = partialMatchVariant.price;

      // NEW: Dynamically map the correct packaging tier based on the user's selected serves!
      let selectedServe = '50 serves'; // Fallback
      Object.values(selectedOptions).forEach(val => {
         if (val && val.toLowerCase().includes('serves')) selectedServe = val.toLowerCase();
      });

      const packAddon = document.getElementById('Addon-PackagingBranding');
      const packLabel = document.getElementById('PackagingBrandingLabel');
      if (packAddon && packLabel) {
         const mappedData = packagingBrandingMap[selectedServe] || packagingBrandingMap['50 serves'];
         packAddon.setAttribute('data-addon-id', mappedData.id);
         packAddon.setAttribute('data-addon-price', mappedData.price);
         packLabel.innerHTML = `Packaging Branding — ${formatMoney(mappedData.price)}`;
      }

      // NEW: Loop through ALL checked addons instantly calculate the total!
      const checkedAddons = document.querySelectorAll('.custom-addon-checkbox:checked');
      checkedAddons.forEach(addon => {
          const addonPrice = parseInt(addon.getAttribute('data-addon-price') || 0);
          totalCents += addonPrice;
          
          let labelText = addon.nextElementSibling.textContent.split('—')[0].trim();
          if (addon.id === 'Generator-Yes') labelText = 'Generator Hire';
          
          summaryList.innerHTML += `<li>${labelText}</li>`;
      });

    // 4. Print the final calculated price
      totalPriceEl.textContent = formatMoney(totalCents);
    }
    
    // --- SYNC ADDON THUMBNAILS ---
    const addonContainer = document.getElementById('AddonThumbnailsContainer');
    if (addonContainer) {
      addonContainer.innerHTML = '';
      let isActiveAddonStillChecked = false;

      // NEW: Grab the current cart image so we can swap it into the thumbnail slot
      const cartImageSrc = (activeImageVariant && activeImageVariant.featured_image) ? activeImageVariant.featured_image.src : '';

      const checkedAddonNodes = document.querySelectorAll('.custom-addon-checkbox:checked');
      checkedAddonNodes.forEach(addonNode => {
         const originalImgUrl = addonNode.getAttribute('data-addon-image');
         if (originalImgUrl) {
            const isCurrentlyActive = (originalImgUrl === activeAddonImageUrl);
            if (isCurrentlyActive) isActiveAddonStillChecked = true;

            const imgEl = document.createElement('img');
            
            // NEW SWAP LOGIC: If this add-on is active, show the cart image as the thumbnail. Otherwise, show the add-on.
            imgEl.src = isCurrentlyActive && cartImageSrc ? cartImageSrc : originalImgUrl;
            
            imgEl.className = 'product-page__additional-image';
            imgEl.style.width = '100px';
            imgEl.style.height = 'auto';
            imgEl.style.cursor = 'pointer';
            imgEl.style.marginTop = '0';
            
            if (isCurrentlyActive) {
                imgEl.style.border = '2px solid #000';
            } else {
                imgEl.style.border = '1px solid #000';
            }

            imgEl.addEventListener('click', function() {
                if (activeAddonImageUrl === originalImgUrl) {
                    activeAddonImageUrl = null;
                } else {
                    activeAddonImageUrl = originalImgUrl;
                    isViewingFoodImage = false; // Turn off food image state
                }
                updateFormState();
            });

            addonContainer.appendChild(imgEl);
         }
      });

      // Revert the main image if the currently viewed add-on was unchecked
      if (activeAddonImageUrl && !isActiveAddonStillChecked) {
          activeAddonImageUrl = null;
      }
    }

    // --- STEP 2 VALIDATION ENGINE ---
    let isStep2Valid = true;

    // 1. A complete variant must be matched (dropdowns can't be on the placeholder)
    if (!matchedVariant) {
        isStep2Valid = false;
    }

// 2. If dynamic variant options are required (container is visible), at least one must be checked
    if (dynamicContainer && dynamicContainer.style.display === 'block') {
        const checkedDynamic = dynamicWrapper.querySelectorAll('input[type="checkbox"]:checked');
        if (checkedDynamic.length === 0) {
            isStep2Valid = false;
        }
    }

    // 3. Lock or Unlock the Continue Button
    const continueBrandingBtn = document.getElementById('ContinueBrandingButton');
    if (continueBrandingBtn) {
        if (isStep2Valid) {
            continueBrandingBtn.style.opacity = '1';
            continueBrandingBtn.style.pointerEvents = 'auto';
            continueBrandingBtn.textContent = 'CONTINUE TO BRANDING';
        } else {
            continueBrandingBtn.style.opacity = '0.5';
            continueBrandingBtn.style.pointerEvents = 'none';
            continueBrandingBtn.textContent = 'MAKE SELECTIONS TO CONTINUE'; 
        }
    }

    // Trigger image/preview engine to ensure it maps correctly if a new variant is clicked
    if (typeof updateImageAndPreview === 'function') updateImageAndPreview(activeImageVariant);
  }

  document.addEventListener('change', function(event) {
    // Added checks for custom-addon-checkbox and any checkbox inside the product-properties
    if (event.target.classList.contains('actual-variant-radio') || 
        event.target.classList.contains('base-filter-radio') ||
        event.target.classList.contains('sub-option-select') ||
        event.target.classList.contains('custom-addon-checkbox') ||
        event.target.classList.contains('generator-radio') ||
        event.target.closest('.product-properties') // add milks to order overview
        ) {
    updateFormState();
    }
  });

  updateFormState();

  // --- DYNAMIC IMAGE & LOGO PREVIEW ENGINE ---
  function updateImageAndPreview(passedVariant = null) {
    const mainImage = document.querySelector('.product-image__wrapper img:not(#LogoPreview)');
    if (!mainImage) return;

    const currentVariantId = masterVariantInput ? masterVariantInput.value : null;
    const variantData = currentVariantId && variantMetafields[currentVariantId] ? variantMetafields[currentVariantId] : null;
    
    // Use the passed partial variant if available, otherwise fall back to the strict ID
    const matchedVariant = passedVariant || variants.find(v => v.id == currentVariantId);
    const cartImageSrc = (matchedVariant && matchedVariant.featured_image) ? matchedVariant.featured_image.src : '';
      
      // FIX: Look at whether the food dropdowns are actually completed, NOT the continue button!
      const isVariantComplete = masterVariantInput && masterVariantInput.dataset.completeVariant === "true";
      const foodImageSrc = (isVariantComplete && variantData && variantData.image) ? variantData.image : '';

// 1. Swap Main Image AND Thumbnail based on memory state
      if (activeAddonImageUrl) {
          // SHOWING ADD-ON IMAGE
          if (mainImage.src !== activeAddonImageUrl) mainImage.src = activeAddonImageUrl;
          
          // Keep food image thumbnail available to click back to
          if (foodImageContainer) {
              if (foodImageSrc) {
                  foodImageContainer.src = foodImageSrc; 
                  foodImageContainer.style.display = 'block';
              } else {
                  foodImageContainer.style.display = 'none';
              }
          }
      } else if (isViewingFoodImage && foodImageSrc) {
          // SHOWING FOOD IMAGE
          if (mainImage.src !== foodImageSrc) mainImage.src = foodImageSrc;
          if (foodImageContainer) {
              foodImageContainer.src = cartImageSrc; // Thumbnail becomes the Cart so they can go back
              foodImageContainer.style.display = 'block';
          }
      } else {
          // SHOWING MAIN CART IMAGE
          if (cartImageSrc && mainImage.src !== cartImageSrc) mainImage.src = cartImageSrc;
          if (foodImageContainer) {
              if (foodImageSrc) {
                  foodImageContainer.src = foodImageSrc; 
                  foodImageContainer.style.display = 'block';
              } else {
                  foodImageContainer.style.display = 'none';
              }
          }
      }

      if (mainImage.hasAttribute('srcset')) mainImage.removeAttribute('srcset');

// 2. Update the Logo Preview Location & Curvature
      if (preview && preview.style.display === 'block') {
          if (activeAddonImageUrl) {
              // NEW: Hide the SVG preview entirely when viewing an add-on image
              preview.style.opacity = '0';
              preview.style.pointerEvents = 'none';
          } else {
              // Restore visibility for Cart or Food images
              preview.style.opacity = '1';
              preview.style.pointerEvents = 'auto';
              
              if (isViewingFoodImage && variantData && variantData.packaging_config) {
                  // Apply Packaging Constraints
                  const config = variantData.packaging_config;
                  preview.style.top = config.top || '50%';
                  preview.style.width = config.width || '30%';
                  preview.style.height = config.height || '30%';
                  
                  const isCirc = config.is_circular ? '50%' : '0';
                  preview.style.borderRadius = isCirc;
                  preview.style.overflow = config.is_circular ? 'hidden' : 'visible';
                  
                  const scaleX = config.scale_x || 1;
                  preview.style.transform = `translateX(-50%) scaleX(${scaleX})`;
                  
              } else {
                  // Revert to Main Cart Constraints
                  const positionVal = logoPositionSelect ? logoPositionSelect.value : 'Bar';
                  applyCartLogoConstraints(preview, positionVal);
                  
                  preview.style.borderRadius = '0';
                  preview.style.overflow = 'visible';
                  
                  const scaleValue = logoSizeSlider ? logoSizeSlider.value : 100;
                  preview.style.transform = `translateX(-50%) scale(${scaleValue / 100})`;
              }
          }
      }

// 3. Lock or Unlock the Cart Editor Sliders
      if (logoEditingContainer) {
          if (cartBrandingCb && cartBrandingCb.checked) {
              logoEditingContainer.style.display = 'block';
              if (isViewingFoodImage || activeAddonImageUrl) {
                  // NEW: Fade out and disable clicks while viewing packaging OR add-ons
                  logoEditingContainer.style.opacity = '0.3';
                  logoEditingContainer.style.pointerEvents = 'none';
              } else {
                  // Light up and enable clicks while viewing cart
                  logoEditingContainer.style.opacity = '1';
                  logoEditingContainer.style.pointerEvents = 'auto';
              }
          } else {
              logoEditingContainer.style.display = 'none';
          }
      }
  }

  function handleBrandingToggles(event) {
    if (event && event.target === yesBrandingRadio && yesBrandingRadio.checked) {
        if (noBrandingRadio) noBrandingRadio.checked = false;
        
        // BUGFIX 1: Open the file uploader automatically if they haven't picked a file yet!
        if (fileInput && (!fileInput.files || fileInput.files.length === 0)) {
            fileInput.click();
        }
    }
    
    if (event && event.target === noBrandingRadio && noBrandingRadio.checked) {
        if (yesBrandingRadio) yesBrandingRadio.checked = false;
    }

    // BUGFIX 2: Smart Auto-Swapping Memory
    if (event && event.target === packBrandingCb) {
        isViewingFoodImage = packBrandingCb.checked; // Auto-switch to food if checked, back to cart if unchecked
    } else if (event && event.target === cartBrandingCb && cartBrandingCb.checked) {
        isViewingFoodImage = false; // Auto-switch back to cart image
    }

    if (yesBrandingRadio && yesBrandingRadio.checked) {
        brandingCheckboxesContainer.style.display = 'block';
    } else {
        brandingCheckboxesContainer.style.display = 'none';
        if (cartBrandingCb) cartBrandingCb.checked = false;
        if (packBrandingCb) packBrandingCb.checked = false;
    }
    
    validateStep3();
    updateFormState();
  }

  if (yesBrandingRadio) yesBrandingRadio.addEventListener('change', handleBrandingToggles);
  if (noBrandingRadio) noBrandingRadio.addEventListener('change', handleBrandingToggles);
  if (cartBrandingCb) cartBrandingCb.addEventListener('change', handleBrandingToggles);
  if (packBrandingCb) packBrandingCb.addEventListener('change', handleBrandingToggles);

  // --- STEP 3 VALIDATION ENGINE ---
  function validateStep3() {
    const continueDetailsBtn = document.getElementById('ContinueDetailsButton');
    if (!continueDetailsBtn) return;

    let isStep3Valid = false;

    if (noBrandingRadio && noBrandingRadio.checked) {
      isStep3Valid = true;
    } else if (yesBrandingRadio && yesBrandingRadio.checked) {
      const hasCheckbox = (cartBrandingCb && cartBrandingCb.checked) || (packBrandingCb && packBrandingCb.checked);
      const hasFile = fileInput && fileInput.files && fileInput.files.length > 0;
      if (hasCheckbox && hasFile) {
        isStep3Valid = true;
      }
    }

    if (isStep3Valid) {
      continueDetailsBtn.style.opacity = '1';
      continueDetailsBtn.style.pointerEvents = 'auto';
      continueDetailsBtn.textContent = 'CONTINUE TO DETAILS';
    } else {
      continueDetailsBtn.style.opacity = '0.5';
      continueDetailsBtn.style.pointerEvents = 'none';
      continueDetailsBtn.textContent = 'MAKE A SELECTION TO CONTINUE';
    }
  }

  if (fileDropArea && fileInput) {
    fileInput.addEventListener('dragenter', () => fileDropArea.classList.add('is-dragover'));
    fileInput.addEventListener('dragleave', () => fileDropArea.classList.remove('is-dragover'));
    fileInput.addEventListener('drop', () => fileDropArea.classList.remove('is-dragover'));
  }

  // 3. Process the file, validate it, and conditionally generate preview
  document.addEventListener('change', function(event) {
    if (event.target && event.target.id === 'CustomLogo') {
      const file = event.target.files[0];
      const errorDisplay = document.getElementById('FileErrorDisplay'); 
    
      if (file) {
        const fileName = file.name.toLowerCase();
        const isSVG = file.type === 'image/svg+xml' || fileName.endsWith('.svg');
        const isPNG = file.type === 'image/png' || fileName.endsWith('.png');
        const isValidImage = isSVG || isPNG;
        
        // 1. Check File Type
        if (!isValidImage) {
          showError('Invalid format. Please upload an SVG or PNG file.');
          return; 
        }

        // 2. Check File Size (e.g., 50MB limit)
        const maxSizeInMB = 50;
        const maxSizeBytes = maxSizeInMB * 1024 * 1024;
        if (file.size > maxSizeBytes) {
          showError(`File is too large. Please keep it under ${maxSizeInMB}MB.`);
          return; 
        }

        // --- SUCCESS PATH ---
        if (errorDisplay) errorDisplay.style.display = 'none'; 
        if (noBrandingRadio) noBrandingRadio.checked = false; 

        // 1. Always ensure "Yes" is checked to save clicks
        if (yesBrandingRadio && !yesBrandingRadio.checked) {
            yesBrandingRadio.checked = true;
        }

        // 2. Always ensure Cart Branding is checked so the logo editor appears for the new file
        if (cartBrandingCb && !cartBrandingCb.checked) {
            cartBrandingCb.checked = true;
        }

        // 3. Always force the main image back to the cart on a fresh upload!
        isViewingFoodImage = false;
        
        handleBrandingToggles(); // run the UI checks and updates the Order Overview!

        if (logoEditingContainer) logoEditingContainer.style.display = 'block';
        
        if (fileNameDisplay) {
          fileNameDisplay.textContent = "File Selected: " + file.name;
          fileNameDisplay.style.display = 'block';
        }

        if (errorDisplay) errorDisplay.style.display = 'none'; 
        if (noBrandingRadio) noBrandingRadio.checked = false; 

        if (logoEditingContainer) logoEditingContainer.style.display = 'block';
        
        if (fileNameDisplay) {
          fileNameDisplay.textContent = "File Selected: " + file.name;
          fileNameDisplay.style.display = 'block';
        }

        if (originalLogoNameInput) originalLogoNameInput.value = file.name;

        // Generate preview for SVGs and PNGs
        if (isValidImage) {
          const objectUrl = URL.createObjectURL(file);
          
          const positionVal = logoPositionSelect ? logoPositionSelect.value : 'Bar';
          applyCartLogoConstraints(preview, positionVal);
          
          preview.style.maxWidth = 'none'; 
          preview.style.maxHeight = 'none';
          preview.style.objectFit = 'contain';
          
          preview.src = objectUrl;
          preview.style.display = 'block';
        } else {
          if (preview) preview.style.display = 'none';
        }

        validateStep3(); // Run validation on successful upload

      } else {
        hideBrandingPreview();
        validateStep3(); // Run validation if file is removed
      }

      // --- HELPER: Handles rejecting the file and showing the error text ---
      function showError(message) {
        event.target.value = ''; 
        hideBrandingPreview(); 
        
        if (errorDisplay) {
          errorDisplay.textContent = message;
          errorDisplay.style.display = 'block';
        }
        
        validateStep3(); // Lock the button if error occurs
      }
    }
  });

  // Move the logo live if the user changes the dropdown after uploading
  if (logoPositionSelect && preview) {
    logoPositionSelect.addEventListener('change', function() {
      if (preview.style.display === 'block') {
        applyCartLogoConstraints(preview, this.value);
      }
    });
  }

  const handleInput = (el) => {
    const min = el.min || 0;
    const max = el.max || 100;
    const pct = (el.value - min) / (max - min) * 100;
    el.style.setProperty('--range-pct', pct + '%');
  };

  // Live scale the logo when the user moves the slider
  if (logoSizeSlider && preview && logoSizeValue) {
    handleInput(logoSizeSlider)
    logoSizeSlider.addEventListener('input', function(e) {
      handleInput(e.target)
      const scaleValue = this.value;
      logoSizeValue.textContent = scaleValue + '%'; 
      
      if (preview.style.display === 'block') {
        preview.style.transform = `translateX(-50%) scale(${scaleValue / 100})`;
      }
    });
  }

  // Handle the "I don't need branding" toggle
  if (noBrandingRadio) {
    noBrandingRadio.addEventListener('change', function() {
      if (this.checked) {
        
        if (yesBrandingRadio) yesBrandingRadio.checked = false; // <-- ADD THIS LINE
        
        fileInput.value = ""; 
        if (logoEditingContainer) logoEditingContainer.style.display = 'none';
        hideBrandingPreview();
        validateStep3(); // Unlock the button when checked
      }
    });
  }

  // Helper: Hides all text and images when cleared
  function hideBrandingPreview() {
      if (preview) preview.style.display = 'none';
      if (fileNameDisplay) fileNameDisplay.style.display = 'none';
      const errorDisplay = document.getElementById('FileErrorDisplay'); 
      if (errorDisplay) errorDisplay.style.display = 'none';

      if (originalLogoNameInput) originalLogoNameInput.value = '';
  }

  // Initialize Step 3 validation on page load
  validateStep3();

  // FORM SUBMISSION 
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(event) {
    event.preventDefault(); 

    // --- 1. APPLY LOADING STATE ---
    const submitBtn = document.getElementById('SubmitCartButton');
    const originalBtnText = submitBtn ? submitBtn.value : 'CONTINUE TO OVERVIEW';
    
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.value = "LOADING OVERVIEW ...";
      submitBtn.style.opacity = '0.7';
    }

    const checkedAddons = document.querySelectorAll('.custom-addon-checkbox:checked');
    let itemsToAdd = [];

    checkedAddons.forEach(checkbox => {
      itemsToAdd.push({
      id: checkbox.getAttribute('data-addon-id'),
      quantity: 1
      });
    });

    function submitMainForm() {
        HTMLFormElement.prototype.submit.call(addToCartForm);
    }

    // --- 2. PROCESS ADDONS & SUBMIT ---
    if (itemsToAdd.length > 0) {
        let addonData = {
        items: itemsToAdd
        };

        // Using a direct root path is also safer if window.Shopify.routes isn't initialized
        fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addonData)
        })
        .then(response => {
          // FIX: Wait 400ms to allow Shopify to finish writing addons to the cart session
          setTimeout(function() {
            submitMainForm(); 
          }, 400);
        })
        .catch(error => {
        console.error('Error adding addons:', error);
        submitMainForm(); 
        });
        
    } else {
      submitMainForm();
    }

    });
  }
  
  const continueBrandingBtn = document.getElementById('ContinueBrandingButton');
  const continueDetailsBtn = document.getElementById('ContinueDetailsButton');
  const submitCartBtn = document.getElementById('SubmitCartButton');
  
  const backBtn = document.getElementById('BackButton');
  
  const step2Content = document.getElementById('Step2Content');
  const step3Content = document.getElementById('Step3Content');
  const step4Content = document.getElementById('Step4Content');
  const stepTitle = document.getElementById('StepTitle');

  // Store the original collection URL so we can revert to it if needed
  const collectionUrl = backBtn ? backBtn.getAttribute('href') : '/collections/all';

  // Keep track of the current step (starts at 2)
  let currentStep = 2;

  function updateView() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    
    const addonThumbnailsWrapper = document.getElementById('AddonThumbnailsContainer');

    if (currentStep === 2) {
      step2Content.style.display = 'block';
      step3Content.style.display = 'none';
      if (step4Content) step4Content.style.display = 'none';
      
      stepTitle.textContent = 'Step 2/4: Choose Your Offering';
      
      continueBrandingBtn.style.display = 'flex';
      continueDetailsBtn.style.display = 'none'; 
      submitCartBtn.style.display = 'none';

      if (addonThumbnailsWrapper) {
        addonThumbnailsWrapper.style.display = 'flex';
        addonThumbnailsWrapper.style.alignItems = 'flex-start';
      }

      backBtn.setAttribute('href', collectionUrl);
      backBtn.onclick = null; 
    } 
    else if (currentStep === 3) {
      step2Content.style.display = 'none';
      step3Content.style.display = 'block';
      if (step4Content) step4Content.style.display = 'none';
      
      stepTitle.textContent = 'Step 3/4: Upload Your Branding';
      
      continueBrandingBtn.style.display = 'none'; 
      continueDetailsBtn.style.display = 'flex'; 
      submitCartBtn.style.display = 'none';
      
      if (addonThumbnailsWrapper) addonThumbnailsWrapper.style.display = 'none'; 
      
      // Revert main image if they were looking at an add-on
      if (activeAddonImageUrl) {
          activeAddonImageUrl = null;
          updateImageAndPreview(); 
      }

      backBtn.setAttribute('href', '#');
      backBtn.onclick = function(event) {
        event.preventDefault();
        currentStep = 2;
        updateView();
      };
    }
    else if (currentStep === 4) {
      step2Content.style.display = 'none';
      step3Content.style.display = 'none';
      if (step4Content) step4Content.style.display = 'block';
      
      stepTitle.textContent = 'Step 4/4: Select Day and Time';
      
      continueBrandingBtn.style.display = 'none'; 
      continueDetailsBtn.style.display = 'none'; 
      submitCartBtn.style.display = 'flex';

      if (addonThumbnailsWrapper) addonThumbnailsWrapper.style.display = 'none'; // Hide addon thumbs

      backBtn.setAttribute('href', '#');
      backBtn.onclick = function(event) {
        event.preventDefault();
        currentStep = 3;
        updateView();
      };
    }
  }

  if (continueBrandingBtn) {
    continueBrandingBtn.addEventListener('click', function(e) {
      e.preventDefault();
      currentStep = 3;
      updateView();
    });
  }

  if (continueDetailsBtn) {
    continueDetailsBtn.addEventListener('click', function(e) {
      e.preventDefault();
      currentStep = 4;
      updateView();
    });
  }

// --- STEP 4 VALIDATION ENGINE ---
  function validateStep4() {
    const submitCartBtn = document.getElementById('SubmitCartButton');
    if (!submitCartBtn) return;

    // Grab all the values from Step 4
    const eventDate = document.getElementById('EventDate')?.value;
    const eventTime = document.getElementById('EventTime')?.value;
    
    const companyName = document.querySelector('input[name="properties[Company Name]"]')?.value.trim();
    const contactName = document.querySelector('input[name="properties[Contact Name]"]')?.value.trim();
    const contactNumber = document.querySelector('input[name="properties[Contact Number]"]')?.value.trim();
    const streetAddress = document.querySelector('input[name="properties[Street Address]"]')?.value.trim();
    const numberApartmentUnit = document.querySelector('input[name="properties[Number Apartment Unit]"]')?.value.trim();
    const city = document.querySelector('input[name="properties[City]"]')?.value.trim();
    const postcode = document.querySelector('input[name="properties[Postcode]"]')?.value.trim();
    const state = document.querySelector('input[name="properties[State]"]')?.value.trim();
    const accessNotes = document.querySelector('textarea[name="properties[Access Notes]"]')?.value.trim();

    // 1. Date Validation
    let isDateValid = false;
    const noticeDays = (window.minDaysNotice || 7) + 1;

    if (eventDate) {
      const selectedDate = new Date(eventDate + 'T00:00:00'); // Parse as local midnight
      const minAllowedDate = new Date();
      minAllowedDate.setHours(0,0,0,0);
      minAllowedDate.setDate(minAllowedDate.getDate() + noticeDays);
      if (selectedDate >= minAllowedDate) {
        isDateValid = true;
      }
    }

    // 2. NEW: Postcode Validation
    let isPostcodeValid = false;
    const postcodeErrorMsg = document.getElementById('PostcodeErrorMsg');

    if (postcode) {
      if (validPostcodes.includes(postcode)) {
          isPostcodeValid = true;
          if (postcodeErrorMsg) postcodeErrorMsg.style.display = 'none';
      } else {
          // Only show the error block if they've typed at least 4 digits 
          // so it doesn't flash errors while they are actively typing.
          if (postcode.length >= 4 && postcodeErrorMsg) {
              postcodeErrorMsg.style.display = 'block';
          } else if (postcodeErrorMsg) {
              postcodeErrorMsg.style.display = 'none';
          }
      }
    } else {
      if (postcodeErrorMsg) postcodeErrorMsg.style.display = 'none';
    }

    // Require both a date value, valid range calculation, AND a valid postcode to proceed
    const isStep4Valid = eventDate && isDateValid && eventTime && contactName && contactNumber && streetAddress && city && postcode && isPostcodeValid && state && accessNotes;

    // Lock or Unlock the Submit Button
    if (isStep4Valid) {
      submitCartBtn.style.opacity = '1';
      submitCartBtn.style.pointerEvents = 'auto';
      submitCartBtn.value = 'CONTINUE TO OVERVIEW'; 
    } else {
      submitCartBtn.style.opacity = '0.5';
      submitCartBtn.style.pointerEvents = 'none';
      
      // Smart button messaging based on the validation failure type
      if (eventDate && !isDateValid) {
        // Dynamically inject the days into the button error text
        submitCartBtn.value = `CHOOSE A DATE ${window.minDaysNotice || 7}+ DAYS OUT`;
      } else if (postcode && !isPostcodeValid && postcode.length >= 4) {
        submitCartBtn.value = 'POSTCODE OUTSIDE SERVICE AREA';
      } else {
        submitCartBtn.value = 'FILL ALL FIELDS TO CONTINUE';
      }
    }
  }

  // Attach listeners to all Step 4 inputs so it updates live as they type/select
  const step4Inputs = [
    document.getElementById('EventDate'),
    document.getElementById('EventTime'),
    document.querySelector('input[name="properties[Company Name]"]'),
    document.querySelector('input[name="properties[Contact Name]"]'),
    document.querySelector('input[name="properties[Contact Number]"]'),
    document.querySelector('input[name="properties[Street Address]"]'),
    document.querySelector('input[name="properties[Number Apartment Unit]"]'),
    document.querySelector('input[name="properties[City]"]'),
    document.querySelector('input[name="properties[Postcode]"]'),
    document.querySelector('input[name="properties[State]"]'),
    document.querySelector('textarea[name="properties[Access Notes]"]')
  ];

  step4Inputs.forEach(input => {
    if (input) {
      input.addEventListener('input', validateStep4);
      input.addEventListener('change', validateStep4);
    }
  });

  // Initialize Step 4 validation on page load
  validateStep4();
});